// components/TimerDisplay.js
import React, { useEffect, useRef, useState } from 'react';

function formatTime(seconds) {
  const m = Math.floor(seconds / 60);
  const s = seconds % 60;
  return `${m}m ${s < 10 ? '0' : ''}${s}s`;
}

const TimerDisplay = React.forwardRef((props, ref) => {
  const [tick, setTick] = useState(0);
  const timeElapsedRef = useRef(0);
  const intervalRef = useRef(null);

  useEffect(() => {
    intervalRef.current = setInterval(() => {
      timeElapsedRef.current += 1;
      setTick(t => t + 1);
    }, 1000);

    return () => clearInterval(intervalRef.current);
  }, []);

  // expose to parent
  React.useImperativeHandle(ref, () => ({
    getTime: () => timeElapsedRef.current,
    reset: () => {
      timeElapsedRef.current = 0;
      setTick(0);
    },
    stop: () => clearInterval(intervalRef.current)
  }));

  return <span>🕒 {formatTime(timeElapsedRef.current)} elapsed</span>;
});

export default TimerDisplay;
